import * as Yup from 'yup'

const loginFormValidationSchema = Yup.object().shape({
  userName: Yup.string()
    // .email('validation.loginForm.emailField.email')
    .required('validation.loginForm.userNameField.required'),
  password: Yup.string()
    .required('validation.loginForm.passwordField.required')
})

export default loginFormValidationSchema
